import { formatDate } from '@btime/helpers'
import React from 'react'

import { findReplyByQuestionId, getReplyValue } from '../../_helpers/pdfHelpers'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { useParentServiceOrder } from '../../_load/ParentServiceOrderLoader'
import Image from '../../../../../components/presentation/Image'
import Separator from '../../../../../components/pdf/Separator'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import OSHeader from './sections/OSHeader'
import OSFooter from './sections/OSFooter'

const OSHeavyMachinesTemplate = () => {
  const parentServiceOrder = useParentServiceOrder()

  const dateTime = formatDate('DD/MM/YYYY', parentServiceOrder.endDate)
  const name = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 41))
  const document = getReplyValue(findReplyByQuestionId(parentServiceOrder.replies, 10))

  return (
    <>
      <View
        pageBreakAfter
        style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
      >
        <Col>
          <OSHeader />
          <Table width="100%" style={{ borderTop: 'none' }}>
            <TableRow>
              <TableCol colSpan={4} bgColor="#dbe4f0">
                <Text bold>1 - NOME</Text>
              </TableCol>
              <TableCol colSpan={2} bgColor="#dbe4f0">
                <Text bold>2 - FUNÇÃO</Text>
              </TableCol>
              <TableCol colSpan={2} bgColor="#dbe4f0">
                <Text bold>3 - DATA ADMISSÃO</Text>
              </TableCol>
            </TableRow>
            <TableRow>
              <TableCol colSpan={4}>
                <Text>{name}</Text>
              </TableCol>
              <TableCol colSpan={2}>
                <Text>Operador de máquinas pesadas III</Text>
              </TableCol>
              <TableCol colSpan={2}>
                <Text>{dateTime}</Text>
              </TableCol>
            </TableRow>
          </Table>

          <Separator weight={2} />

          <Table width="100%">
            <TableRow>
              <TableCol colSpan={4} bgColor="#dbe4f0">
                <Text bold>4 - ATIVIDADES</Text>
              </TableCol>
            </TableRow>
            <TableRow>
              <TableCol colSpan={2}>
                <Text>
                  4.1 – Operar caminhão 6x4, carreta, caminhão pipa e máquinas pesadas como: escavadeiras,
                  retroescavadeira, rolo compactador, trator de esteira, motoniveladora, pá carregadeira entre outros
                  equipamentos da empresa acordo com a sua capacitação e habilitação e instruções técnicas dos
                  fabricantes;
                </Text>
                <Text>
                  4.2 - Realizar manutenções básicas de máquinas pesadas e zelar pelas manutenções reparos para
                  assegurar o bom funcionamento e a segurança das operações destas máquinas
                </Text>
                <Text>
                  4.3 - Executar as atividades de acordo com normas e procedimentos zelando pela segurança própria,
                  coletiva e de terceiros, utilizando equipamentos de proteção apropriados quando da execução dos
                  serviços;
                </Text>
                <Text>4.4 - Efetuar anotações na parte diária da máquina.</Text>
                <Text>4.5 - Executar pequenas intervenções mecânicas, quando necessário</Text>
              </TableCol>
            </TableRow>
          </Table>

          <Separator weight={2} />

          <Table width="100%">
            <TableRow>
              <TableCol colSpan={4} bgColor="#dbe4f0">
                <Text bold>5 - RISCOS DAS ATIVIDADES</Text>
              </TableCol>
            </TableRow>
            <TableRow>
              <TableCol colSpan={2}>
                <Text>
                  5.1 - Acidentes com veículo ou máquinas pesadas (tombamento, atropelamento, colisão, abalroamento,
                  choque, capotamento);
                </Text>
                <Text>5.2 - Queda de diferença de nível, queda em mesmo nível;</Text>
                <Text>5.3 - Poeiras respiráveis (trânsito de veículos e movimentações de materiais);</Text>
                <Text>5.4 - Ruído (máquinas e equipamentos);</Text>
                <Text>5.5 - Radiação não ionizante (sol);</Text>
                <Text>5.6 - Prensamento e/ou esmagamento de membros;</Text>
                <Text>5.7 - Queda de materiais, soterramento;</Text>
                <Text>5.8 - Postura inadequada, fadiga, estresse, falta de atenção;</Text>
                <Text>
                  5.9 -Outros possíveis riscos ambientais (Físicos, Químicos, Biológicos, Ergonômicos e de Acidentes),
                  conforme Programa de Gerenciamento de Riscos- PGR.
                </Text>
              </TableCol>
            </TableRow>
          </Table>

          <Separator weight={2} />

          <Table width="100%">
            <TableRow>
              <TableCol colSpan={4} bgColor="#dbe4f0">
                <Text bold>6 - EPIs BÁSICOS DE USO OBRIGATÓRIO (QUANDO APLICÁVEL)</Text>
              </TableCol>
            </TableRow>
            <TableRow>
              <TableCol colSpan={2}>
                <Text>6.1 - EPI’ uso constante - calçado de Segurança com solado PU e biqueira de composite.</Text>
                <Text>
                  6.2 - EPI’ de uso especifico – capacete com jugular, protetor auditivo tipo concha, protetor auditivo
                  tipo plug, creme bloqueador solar, perneira de segurança, capa de chuva, óculos de proteção com lentes
                  incolores e óculos de proteção com lentes tonalidade escura.
                </Text>
                <Text>6.3 - Uniformes – Camisa de manga longa e calça comprida;</Text>
                <Text>6.4 - Colete luminoso;</Text>
                <Text>6.5 - Respirador purificador de ar.</Text>
              </TableCol>
            </TableRow>
          </Table>

          <Separator weight={2} />

          <Table width="100%">
            <TableRow>
              <TableCol colSpan={4} bgColor="#dbe4f0">
                <Text bold>7 - MEDIDAS PREVENTIVAS</Text>
              </TableCol>
            </TableRow>
            <TableRow>
              <TableCol colSpan={2}>
                <Text>
                  7.1 - Uso de EPIs conforme Atividade ou Operação de acordo com a NR 06 da Portaria 3.214, de 08 de
                  Junho de 1978;
                </Text>
                <Text>
                  7.2 - Submeter-se a exames médicos previstos nas Normas Regulamentadoras – NR e de acordo com o
                  previsto no Programa de Controle Médico e Saúde Ocupacional - PCMSO;
                </Text>
                <Text>
                  7.3 Obedecer irrestritamente às normas da Empresa e da Contratante quanto aos aspectos de Qualidade,
                  Segurança e Controle Ambiental, utilizando adequadamente EPI’s, EPC’s e uniformes, assumindo padrões
                  de comportamento seguro e condutas pessoais adequadas no local de trabalho;
                </Text>
                <Text>
                  7.4 - Executar as atividades somente para as quais tenha recebido capacitação, qualificação e
                  treinamentos de acordo com as Normas especificas;
                </Text>
                <Text>
                  7.5 - Conduzir/operar somente veículos, máquinas e/ou equipamentos de acordo com sua habilitação;
                </Text>
                <Text>7.6 - Participar dos treinamentos necessários para execução segura de suas atividades;</Text>
                <Text>
                  7.7 - Atuar de forma preventiva para evitar as não conformidades que possam provocar acidentes
                  pessoais, materiais, com terceiros ou patrimoniais.
                </Text>
                <Text>7.8 - Zelar pela segurança própria, de seus companheiros de equipe, bem como de terceiros.</Text>
                <Text>
                  7.9 - Participar de acordo com orientações da empresa ou da contratante dos Diálogos Diários de
                  Segurança – DDS.
                </Text>
                <Text>7.10 - Cumprir e respeitar o horário de expediente e intervalo para a refeição.</Text>
              </TableCol>
            </TableRow>
          </Table>
        </Col>

        <OSFooter />
      </View>

      <Separator weight={4} />

      <View
        pageBreakAfter
        style={{ minHeight: '27cm', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
      >
        <Col>
          <OSHeader startPage="2" />
          <Table width="100%" style={{ borderTop: 'none' }}>
            <TableRow>
              <TableCol colSpan={4} bgColor="#dbe4f0">
                <Text bold>8 - PROCEDIMENTOS EM CASO DE ACIDENTE</Text>
              </TableCol>
            </TableRow>
            <TableRow>
              <TableCol colSpan={2}>
                <Text>
                  8.1 - Comunicar imediatamente ao superior imediato e/ou ao Técnico em Segurança do Trabalho a
                  ocorrência de acidente, de trajeto ou doença profissional (na ausência do encarregado e/ou do Técnico
                  de segurança, comunique a ocorrência ao superior imediato presente na obra no momento do acidente);
                </Text>
                <Text>
                  8.2 - Agir de acordo com os procedimentos de emergência existentes, prestando os primeiros socorros à
                  vítima (se houver);
                </Text>
                <Text>8.3 - Acionar equipe de resgate interna (se houver na empresa) ou externa;</Text>
                <Text>
                  8.4 - No caso de acidente de trajeto envolvendo veículos, apresentar Boletim de Ocorrência policial
                  para investigação da ocorrência e posterior emissão de CAT;
                </Text>
              </TableCol>
            </TableRow>
          </Table>

          <Separator weight={2} />

          <Table width="100%">
            <TableRow>
              <TableCol colSpan={4} bgColor="#dbe4f0">
                <Text bold>9 - PROIBIÇÕES</Text>
              </TableCol>
            </TableRow>
            <TableRow>
              <TableCol colSpan={2}>
                <Text>9.1 - Deixar de usar os EPIs e EPCs necessários para as atividades;</Text>
                <Text>9.2 - Operar equipamentos sem treinamento e/ou sem autorização;</Text>
                <Text>
                  9.3 - Apresentar-se ao trabalho embriagado, fazer ingestão de bebida alcoólica ou fazer uso de
                  qualquer substância química ilícita durante a jornada de trabalho;
                </Text>
                <Text>9.4 - Acessar a área de trabalho portando arma de fogo ou arma branca de qualquer espécie;</Text>
                <Text>9.5 - Operar equipamentos defeituosos;</Text>
                <Text>9.6 - Fumar em locais proibidos;</Text>
                <Text>9.7 - Descumprir as Normas de Segurança e Medicina do trabalho da Empresa;</Text>
                <Text>
                  9.8 - Realizar brincadeiras e/ou praticar atos que comprometa a segurança própria, da equipe ou de
                  terceiros durante a jornada de trabalho;
                </Text>
                <Text>9.9 - Correr no local de trabalho;</Text>
                <Text>
                  9.10 - Utilizar equipamentos ou ferramentas de forma improvisada ou fora da atividade para a qual se
                  destinam;
                </Text>
                <Text>9.11 - Improvisar consertos em máquinas/equipamentos;</Text>
                <Text>
                  9.12 - Retirar proteção de máquinas, equipamentos ou área de trabalho oferecendo risco de acidente;
                </Text>
                <Text>9.13 - Apresentar-se para o trabalho sem estar devidamente uniformizado;</Text>
              </TableCol>
            </TableRow>
          </Table>

          <Separator weight={2} />

          <Table width="100%">
            <TableRow>
              <TableCol colSpan={4} bgColor="#dbe4f0">
                <Text bold>10 – PENALIDADES EM CASO DE DESCUMPRIMENTO DESTA ORDEM DE SERVIÇO – O.S</Text>
              </TableCol>
            </TableRow>
            <TableRow>
              <TableCol colSpan={2}>
                <Text>
                  10.1 - Em caso de descumprimento dos procedimentos estabelecidos por esta Ordem de Serviço- O.S, serão
                  aplicadas as medidas administrativas cabíveis conforme política de segurança da empresa e de acordo
                  com o Artigo 158 da CLT parágrafo único (redação dada pela lei 6.514/77), da Norma Regulamentadora NR
                  – 01, Item 1.8, Subitem 1.8.1 e conforme previsto no Art. 482 da CLT, considera que a recusa ao fiel
                  cumprimento desta Ordem de Serviço, no todo ou em parte, constitui ATO FALTOSO sujeitando o empregado
                  às penalidades previstas na lei, inclusive gerando demissão por justa causa, conforme sequência
                  abaixo:
                  <Text>− 01 Advertência por escrito; </Text>
                  <Text>
                    − 01 Suspensão do trabalho (tempo a ser determinado de acordo com a gravidade da falta cometida);
                  </Text>
                  <Text>
                    − Dispensa por justa causa, caso as advertências e suspensões cabíveis tenham sido aplicadas e não
                    tenham surtido o efeito esperado;
                  </Text>
                  <Text>
                    − Descontos em salários ou indenizações em caso de danos propositais ou extravios dos EPIs, conforme
                    previsto no Art.462 § 1°da CLT.
                  </Text>
                </Text>
              </TableCol>
            </TableRow>
          </Table>
        </Col>

        <OSFooter />
      </View>

      <Separator weight={4} />

      <View pageBreakAfter style={{ minHeight: '27cm' }}>
        <OSHeader startPage="3" />
        <Table width="100%" style={{ borderTop: 'none' }}>
          <TableRow>
            <TableCol colSpan={4} bgColor="#dbe4f0">
              <Text bold>11 - RECOMENDAÇÕES</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol colSpan={2}>
              <Text>11.1 - A obra é lugar de trabalho. Brincadeiras devem ser reservadas para as horas de folga;</Text>
              <Text>11.2 - Conheça as regras de segurança do setor onde você trabalha e da obra em geral;</Text>
              <Text>
                11.3 - Pergunte ao seu superior imediato, quando não souber ou tiver dúvidas sobre algum serviço e
                comunique toda e qualquer anormalidade ou defeito que notar na máquina, equipamento ou ferramenta que
                for utilizar;
              </Text>
              <Text>
                11.4 - Atenda as instruções e recomendações dos seus companheiros de trabalho e dos profissionais de
                segurança do trabalho;
              </Text>
              <Text>
                11.5 - Leia e reflita sempre quanto aos ensinamentos contidos nos cartazes e avisos sobre segurança e
                higiene no trabalho existentes no seu local de trabalho;
              </Text>
              <Text>
                11.7 - Coopere com a segurança de todos e lembre-se:{' '}
                <strong>“A VIDA DE CADA UM É TÃO PRECIOSA QUANTO A SUA”;</strong>
              </Text>
              <Text>
                11.8 - Habitue-se a trabalhar protegido contra os acidentes e doenças ocupacionais. Manda a lei que o
                seu empregador forneça gratuitamente os equipamentos de proteção individual - EPIs e vestimentas que
                você necessita para trabalhar, mas, você também está obrigado a usá-los corretamente e zelar por sua
                conservação e higiene;
              </Text>
              <Text>
                11.9 - Use óculos sempre que o seu trabalho o exigir e é proibido o uso de óculos escuro à noite e
                quando estiver o tempo nublado;
              </Text>
              <Text>
                11.10 - Use proteção respiratória contra exposição ambiental a poeira, gases e outras substâncias
                prejudiciais a sua saúde;
              </Text>
              <Text>
                11.12 - Uniformes inadequados ou impróprios, bem como cabelos soltos, anéis, alianças, pulseiras,
                relógios, bonés, têm causado graves e irreparáveis lesões no trabalho.{' '}
                <strong>FAÇA DA SEGURANÇA UM HÁBITO”;</strong>
              </Text>
              <Text>
                11.15 - É proibido portar e falar no celular na área de trabalho, principalmente quando estiver
                conduzindo/operando veículos, máquinas e equipamentos;
              </Text>
              <Text>
                11.17 - Se você não é eletricista, não está autorizado a realizar serviços de eletricidade, comunique ao
                seu superior para que ele possa acionar um profissional habilitado;
              </Text>
              <Text>
                11.18 - Mantenha as guardas protetoras das partes móveis das máquinas nos seus devidos lugares;
              </Text>
              <Text>11.19- Executar as atividades diárias preocupando-se com a Conservação do Meio Ambiente;</Text>
              <Text>
                11.20- É obrigatório realizar diariamente a limpeza, separação adequada de resíduos (coleta seletiva) e
                a organização dos materiais que serão utilizados durante a execução das atividades;
              </Text>
              <Text>11.21 - Economize os recursos naturais;</Text>
              <Text>
                11.22 - Fume somente onde for permitido (fumódromo) e conheça o manejo dos extintores de incêndio
                existentes na obra; você poderá precisar usálos algum dia;
              </Text>
              <Text>
                11.23 - Se por acaso você for acidentado, comunique a ocorrência ao seu superior imediato, para que
                medidas sejam tomadas;
              </Text>
              <Text>
                11.24 - A pressa é companheira inseparável dos acidentes. Planeje seu trabalho com tempo, com segurança
                e dificilmente se acidentará;
              </Text>
            </TableCol>
          </TableRow>
        </Table>

        <Separator weight={2} />

        <Table width="100%">
          <TableRow>
            <TableCol colSpan={4} bgColor="#dbe4f0">
              <Text bold>12 - DECLARAÇÃO</Text>
            </TableCol>
          </TableRow>
          <TableRow>
            <TableCol colSpan={2}>
              <Text>
                12.1 - Declaro que recebi da <strong>Empresa Bosi Terraplanagem LTDA</strong>, a ordem de serviço, de
                mesmo teor desta que agora assino e ter tomado ciência referente às minhas funções e uso adequado dos
                equipamentos de proteção individual e coletivo. e que o referido documento foi elaborado atendendo a
                legislação trabalhista em vigor, a qual cumprirei. Tomo ciência também, que o não cumprimento de
                qualquer item desta <strong>ORDEM DE SERVIÇO – O.S</strong> implica em punição, de acordo com a
                legislação trabalhista e normas da empresa.
              </Text>
              <Separator weight={4} />
              <Text>
                “Esta ordem de serviço tem por finalidade cumprir as disposições legais e regulamentares sobre segurança
                e saúde do trabalho, inclusive as ordens de serviço expedidas pelo empregador, conforme disposto na
                Norma Regulamentadora 01, Item 1.8, alínea “a”, do Ministério do Trabalho e Emprego, conscientizá-lo
                para a prática de segurança e saúde no desempenho de suas atribuições e ainda, cientificá-lo de que o
                descumprimento do seu conteúdo sujeita o infrator às penas da lei, que vão desde advertência, suspensão
                e até demissão por justa causa”.
              </Text>
              <Separator weight={4} />
              <Text>
                <strong>Observação:</strong> As orientações aqui contidas não esgotam o assunto sobre prevenção de
                acidentes, devendo ser observadas todas as instruções existentes, ainda que verbais em especial as
                Normas e Regulamentos da Empresa.
              </Text>
            </TableCol>
          </TableRow>
        </Table>

        <Separator weight={6} />

        <Grid align="flex-end">
          <Col width="50%" gutter={8}>
            <Text align="center">___________________________________________________</Text>
            <Text align="center">ASSINATURA DO EMPREGADO</Text>
            <Text align="center">{name}</Text>
            <Text align="center" bold>
              CPF {document}
            </Text>
          </Col>
          <Col width="50%" gutter={8}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{ marginBottom: '-20px' }}>
                <Image src="/pdfs/bosi/assinatura-empregador.png" width="100px" />
              </div>
              <Text align="center">___________________________________________________</Text>
              <Text align="center">ASSINATURA DO EMPREGADOR</Text>
              <Text align="center">Bosi Terraplanagem Ltda</Text>
              <Text align="center" bold>
                CNPJ 42.855.431/0001-80
              </Text>
            </div>
          </Col>
        </Grid>

        <Separator weight={6} />

        <OSFooter />
      </View>
    </>
  )
}

export default OSHeavyMachinesTemplate
